export const onDownloadMultipleFiles = async ({ urls }) => {
  try {
    const downloadPromises = urls.map(async (url) => {
      const response = await fetch(url)
      const blob = await response.blob()
      const fileName = url.substring(url.lastIndexOf('/') + 1)
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      window.URL.revokeObjectURL(link.href)
      document.body.removeChild(link)
    })
    await Promise.all(downloadPromises)
  } catch (error) {
    console.error('Error downloading files:', error)
  }
}

export default onDownloadMultipleFiles